const Metr = n => ( n.toString().indexOf('.') !== -1 || n.toString().indexOf(',') !== -1 || n.toString().length === 1 ) 
  ? parseFloat( n.toString().replace( ',', '.' ) ) 
  : (+n / 1000).toFixed( 3 );

export default Metr;